import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SubmissionAttachment } from '../../../../models/submissions/submission-attachment';
import { FileUploadFieldComponent } from '../../../../ui/form-components/file-uploader/file-upload-field/file-upload-field.component';
import { FileUploaderTextComponent } from '../../../../ui/form-components/file-uploader/file-uploader-text/file-uploader-text.component';
import { FileListItemComponent } from '../../../../ui/file-list-item/file-list-item.component';
import { AttachmentLinkPipe } from '../../../../pipes/attachment-link.pipe';

@Component({
  selector: 'app-account-file-upload',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FileUploadFieldComponent,
    FileUploaderTextComponent,
    FileListItemComponent,
    AttachmentLinkPipe
  ],
  templateUrl: './account-file-upload.component.html',
  styleUrls: ['./account-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountFileUploadComponent {
  @Input({ required: true }) formSubmitted!: boolean;
  @Input({ required: true }) formGroup!: FormGroup<{ files: FormControl<File[]> }>;
  @Input() existingFiles: SubmissionAttachment[] = [];
  @Output() removeFile = new EventEmitter<SubmissionAttachment>();
}
